import React, { ReactNode, useEffect, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import Select, { SelectProps } from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { FieldHookConfig, useField } from "formik";
import { InputLabel } from "@material-ui/core";

const ITEM_HEIGHT = 32;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: (ITEM_HEIGHT * 4.5) + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export interface MultiSelectProps extends SelectProps {
  onClose?: () => void;
  onOpen?: () => void;
  children?: ReactNode[];
  name: string,
  options: string[]
  label?: string;
}
interface ItemProps {
  option: string;
  value?: string[]
}
const renderItemOption = ({ option, value }: ItemProps, index: number): ReactNode => (
  <MenuItem value={option} key={`select-${value}-${index}`}>
    <Checkbox checked={value && value.indexOf(option) > -1} />
    <ListItemText primary={option} />
  </MenuItem>
);

export const MultiSelect: React.FC<MultiSelectProps & FieldHookConfig<any>> =
(props: MultiSelectProps & FieldHookConfig<any>) => {
  const [field, meta, helpers] = useField(props);
  const { name, children, options, onClose, onOpen, open, ...passThrough } = props;
  const customProps = (typeof open === "undefined") ? {} : { onClose, onOpen, open };
  const { value } = field;
  const { touched, error } = meta;
  const { setValue, setTouched } = helpers;
  const handleChange = (e: any) => {
    setValue(e.target.value);
    setTouched(true);
  };
  const [usedOptions, setUsedOptions] = useState<string[]>([]);
  useEffect(() => options && setUsedOptions(options), [options]);
  const salt = Math.floor(Math.random() * 10000);
  const labelNode = <InputLabel id={`${name}-label-${salt}`} variant="outlined">{props.label}</InputLabel>;
  return (
    <FormControl
      variant="outlined"
      hiddenLabel={!props.label}
      margin={props.margin || "dense"}
      fullWidth={props.fullWidth}
    >
      {props.label && labelNode}
      <Select
        labelId={props.label && `${name}-label-${salt}`}
        {...customProps}
        displayEmpty
        multiple
        name={name}
        value={value}
        onClick={() => setTouched(true)}
        onChange={handleChange}
        renderValue={(selected) => (
          Array.isArray(selected) ? (
            (selected.length > 3 && `Selected (${selected.length})`) || selected.join(", ")
          ) : selected) as ReactNode}
        MenuProps={MenuProps}
        SelectDisplayProps={{ style: {
          minWidth: "7em",
        } }}
        inputProps={{ size: "small" }}
        {...passThrough}
      >
        {usedOptions.map((option) => ({ option, value })).map(renderItemOption)}
        {children}
      </Select>
      {touched && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
